export default __webpack_public_path__ + "media/media/step2_js-df8c2948.mp4";